/**
 * AutoLux FAQ Accordion
 * Native grid-template-rows CSS transition for smooth open/close.
 */
(function () {
  'use strict';

  function initFAQ(wrap) {
    var items = wrap.querySelectorAll('.al-faq__item');
    items.forEach(function (item) {
      var btn    = item.querySelector('.al-faq__question');
      var answer = item.querySelector('.al-faq__answer');
      if (!btn || !answer) return;
      item.setAttribute('aria-expanded', 'false');
      answer.setAttribute('hidden', '');
      btn.addEventListener('click', function () {
        var expanded = item.getAttribute('aria-expanded') === 'true';
        items.forEach(function (other) {
          if (other !== item) {
            other.setAttribute('aria-expanded', 'false');
            var otherAnswer = other.querySelector('.al-faq__answer');
            if (otherAnswer) otherAnswer.setAttribute('hidden', '');
          }
        });
        if (expanded) {
          item.setAttribute('aria-expanded', 'false');
          answer.setAttribute('hidden', '');
        } else {
          item.setAttribute('aria-expanded', 'true');
          answer.removeAttribute('hidden');
        }
      });
    });
  }

  function init() {
    var faqs = document.querySelectorAll('.al-faq__list');
    faqs.forEach(initFAQ);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { init(); });
  }
})();
